let navStartTime = undefined;
export const setNavStartTime = time => {
  navStartTime = time;
};
export const getNavStartTime = () => {
  return navStartTime;
};